module.exports = __webpack_public_path__ + "img/addIcon.ab23594a.svg";